import React from 'react'
import bg from "../assets/images/onboarding.svg"
import info from "../assets/images/info-temp.svg"
import { Typography } from '@mui/material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// import { useMode } from '../context/AuthContext';
function TempOnBoard({EntityData,callback , type }) {
  // const {setMode : callback} = useMode();
  return (
    <>  
        {/* <div style={{position:"absolute",right:"5%",top:"5%"}}>
       </div> */}
        <div className='onboard_logo'>
        <img src={bg}></img>
        </div>
        <div className='onboardForm'>
        <div className='info_logo'>
        <img src={info}></img>
        </div>
        <p style={{textAlign:"right",padding:"1rem",color:"red",cursor:"pointer"}} onClick={()=>{
          callback(false)
          if(type !== 'entityCreation'){
          localStorage.clear()
          window.location.reload()
          }
          }}><HighlightOffIcon/></p>
        <Typography variant="h5" fontFamily={"Figtree, sans-serif"} textAlign={"center"}
         lineHeight={"2.5rem"} padding={"3rem"} fontWeight={900} marginBottom={"1rem"} paddingBottom={"1rem"}
          gutterBottom>{type !== 'entityCreation' ?`Your login request is being processed. Kindly wait until your entity admin approves your request. Thank you for your patience.` : `Your Entity creation request is being processed. Kindly wait until your entity admin approves your request. Thank you for your patience.` }</Typography>
         {EntityData?.entityAdminData?.length > 0 && <div style={{display:"flex",width:"100%",padding:".3rem 1rem"}}>
         <p style={{width:"50%"}}>Entity Admin Contact</p>
         <p style={{width:"50%"}}>{EntityData?.entityAdminData?.map((d)=><p>{d?.email}</p>)}</p>
        </div>}
        {EntityData?.data?.crossBorder?.relationshipManagers?<div style={{display:"flex",width:"100%",padding:".5rem 1rem"}}>
         <p style={{width:"50%"}}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} CB Relationship Manager</p>
         <p style={{width:"50%"}}>
         {EntityData?.data?.crossBorder?.relationshipManagers.map((x,z)=> {
          return    <span> {x?.email}</span>
         })
         }
         </p>
         
        </div>:null}
        {EntityData?.data?.domesticTransport?.relationshipManagers?<div style={{display:"flex",width:"100%",padding:".5rem 1rem"}}>
         <p style={{width:"50%"}}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} DT Relationship Manager</p>
          <p style={{ width: "50%" }}>
            {EntityData?.data?.domesticTransport?.relationshipManagers.map((x, z) => {
              return <span> {x?.email}</span>
            })
            }
          </p>
        </div>:null}
        {EntityData?.data?.crossBorder?.customerService?<div style={{display:"flex",width:"100%",padding:".5rem 1rem"}}>
          <p style={{ width: "50%" }}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} CB Customer Service</p>
         <p style={{width:"50%"}}>
         {EntityData?.data?.crossBorder?.customerService.map((x,z)=> {
          return    <span> {x?.email}</span>
         })
         }
         </p>
        </div>:null}
        {EntityData?.data?.domesticTransport?.customerService? <div style={{display:"flex",width:"100%",padding:".5rem 1rem"}}>
         <p style={{width:"50%"}}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} DT Customer Service</p>
          <p style={{width:"50%"}}>
         {EntityData?.data?.domesticTransport?.customerService.map((x,z)=> {
          return    <span> {x?.email}</span>
         })
         }
         </p>
        </div>:null}
         <div style={{display:"flex",width:"100%",padding:".5rem 1rem",paddingBottom:"1rem"}}>
         <p style={{width:"50%"}}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Product Adoption</p>
         <p style={{width:"50%"}}>pat@{process.env.REACT_APP_ENTERPRISE_DOMAIN}</p>
        </div>
        </div>
    </>
  )
}

export default TempOnBoard